
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/resources/freight-templates/certificate-of-origin",
      function () {
        return require("private-next-pages/resources/freight-templates/certificate-of-origin/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/resources/freight-templates/certificate-of-origin"])
      });
    }
  